import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { Logo } from 'components/logo/logo';
import { Styled } from './auth.styled';
import { ThemeToggle } from 'app/layouts/nav-layout';
import moment from 'moment-jalaali';

export default function AuthPage(): JSX.Element {
    const [phone, setPhone] = useState('');
    const currentYear = moment().format('jYYYY');

    return (
        <Styled.Container disableGutters maxWidth={false}>
            <Styled.LeftBox>
                <Styled.LogoContainer>
                    <Link
                        href="https://aqayepardakht.ir"
                        target="_blank"
                        style={{ width: 'fit-content' }}>
                        <Logo />
                    </Link>

                    <Outlet context={[phone, setPhone]} />
                </Styled.LogoContainer>
                <Styled.FooterContainer>
                    <Styled.FooterLink
                        href="https://aqayepardakht.ir/"
                        target="_blank">
                        بازگشت به صفحه اصلی
                    </Styled.FooterLink>

                    <Box sx={{ display: 'flex', mt: 2 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                fontSize: 13,
                                alignItems: 'center',
                            }}>
                            <i className="fa-regular fa-copyright"></i>
                            <Typography sx={{ fontSize: 12, ml: 0.5 }}>
                                {`آقای پرداخت ${currentYear} - 1395`}
                            </Typography>
                        </Box>
                    </Box>
                </Styled.FooterContainer>
            </Styled.LeftBox>

            <Styled.RightBox>
                <img
                    src="/images/login.jpeg"
                    style={{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        maxWidth: '600px',
                        objectFit: 'contain',
                    }}
                    alt="آقای پرداخت"
                />
            </Styled.RightBox>

            <Box sx={{ position: 'fixed', bottom: '20px', left: '20px' }}>
                <ThemeToggle />
            </Box>
        </Styled.Container>
    );
}
